<template>
  <div class="app-container">
    <!-- 搜索栏 -->
    <el-card class="search-card" shadow="never">
      <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="90px">
        <el-form-item label="订单编号" prop="orderNo">
          <el-input
                  v-model="queryParams.orderNo"
                  placeholder="请输入订单编号"
                  clearable
                  style="width: 200px"
                  @keyup.enter.native="handleQuery"
          />
        </el-form-item>

        <el-form-item label="收货人" prop="consignee">
          <el-input
                  v-model="queryParams.consignee"
                  placeholder="请输入收货人"
                  clearable
                  style="width: 120px"
                  @keyup.enter.native="handleQuery"
          />
        </el-form-item>

        <el-form-item label="手机号" prop="phone">
          <el-input
                  v-model="queryParams.phone"
                  placeholder="请输入手机号"
                  clearable
                  style="width: 140px"
                  @keyup.enter.native="handleQuery"
          />
        </el-form-item>

        <el-form-item label="订单状态" prop="status">
          <el-select v-model="queryParams.status" placeholder="请选择状态" clearable style="width: 120px">
            <el-option label="全部" value="" />
            <el-option label="待支付" :value="0" />
            <el-option label="拼团中" :value="1" />
            <el-option label="待发货" :value="2" />
            <el-option label="待收货" :value="3" />
            <el-option label="已完成" :value="4" />
            <el-option label="已取消" :value="5" />
            <el-option label="已退款" :value="6" />
          </el-select>
        </el-form-item>

        <el-form-item label="支付方式" prop="payType">
          <el-select v-model="queryParams.payType" placeholder="请选择" clearable style="width: 100px">
            <el-option label="全部" value="" />
            <el-option label="微信" :value="1" />
            <el-option label="支付宝" :value="2" />
            <el-option label="余额" :value="3" />
          </el-select>
        </el-form-item>

        <el-form-item label="下单时间" prop="createTime">
          <el-date-picker
                  v-model="dateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  style="width: 240px"
          />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 统计卡片 -->
    <el-row :gutter="20" class="stats-row">
      <el-col :span="6">
        <el-card shadow="hover" class="stats-card">
          <div class="stats-content">
            <div class="stats-icon" style="background: #36a3f7;">
              <i class="el-icon-shopping-bag-1"></i>
            </div>
            <div class="stats-info">
              <div class="stats-title">今日订单</div>
              <div class="stats-value">{{ stats.todayCount }}</div>
            </div>
          </div>
        </el-card>
      </el-col>

      <el-col :span="6">
        <el-card shadow="hover" class="stats-card">
          <div class="stats-content">
            <div class="stats-icon" style="background: #34bfa3;">
              <i class="el-icon-circle-check"></i>
            </div>
            <div class="stats-info">
              <div class="stats-title">待发货</div>
              <div class="stats-value">{{ stats.waitShip }}</div>
            </div>
          </div>
        </el-card>
      </el-col>

      <el-col :span="6">
        <el-card shadow="hover" class="stats-card">
          <div class="stats-content">
            <div class="stats-icon" style="background: #f4516c;">
              <i class="el-icon-money"></i>
            </div>
            <div class="stats-info">
              <div class="stats-title">今日金额</div>
              <div class="stats-value">¥{{ stats.todayAmount }}</div>
            </div>
          </div>
        </el-card>
      </el-col>

      <el-col :span="6">
        <el-card shadow="hover" class="stats-card">
          <div class="stats-content">
            <div class="stats-icon" style="background: #ffb822;">
              <i class="el-icon-user"></i>
            </div>
            <div class="stats-info">
              <div class="stats-title">成团率</div>
              <div class="stats-value">{{ stats.successRate }}%</div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 操作栏 -->
    <el-card class="operate-card" shadow="never">
      <el-row :gutter="10" class="mb8">
        <el-col :span="1.5">
          <el-button
                  type="primary"
                  icon="el-icon-download"
                  @click="handleExport"
                  v-hasPermi="['order:export']"
          >
            导出订单
          </el-button>
        </el-col>

        <!-- 批量操作 -->
        <el-col :span="2">
          <el-dropdown @command="handleBatchCommand">
            <el-button :disabled="multiple">
              批量操作<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="batchShip" icon="el-icon-truck">
                批量发货
              </el-dropdown-item>
              <el-dropdown-item command="batchComplete" icon="el-icon-circle-check">
                批量完成
              </el-dropdown-item>
              <el-dropdown-item command="batchCancel" icon="el-icon-circle-close">
                批量取消
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>

        <!-- 订单筛选 -->
        <el-col :span="1.5">
          <el-dropdown @command="handleQuickFilter">
            <el-button>
              快捷筛选<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="waitPay" icon="el-icon-time">
                待支付订单
              </el-dropdown-item>
              <el-dropdown-item command="waitShip" icon="el-icon-truck">
                待发货订单
              </el-dropdown-item>
              <el-dropdown-item command="waitReceive" icon="el-icon-box">
                待收货订单
              </el-dropdown-item>
              <el-dropdown-item command="today" icon="el-icon-date">
                今日订单
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>

        <!-- 订单类型 -->
        <el-col :span="2">
          <el-radio-group v-model="queryParams.type" @change="handleQuery">
            <el-radio-button label="">全部</el-radio-button>
            <el-radio-button :label="1">单独开团</el-radio-button>
            <el-radio-button :label="2">参与拼团</el-radio-button>
          </el-radio-group>
        </el-col>
      </el-row>
    </el-card>

    <!-- 订单列表 -->
    <el-card class="table-card" shadow="never">
      <el-table
              v-loading="loading"
              :data="orderList"
              @selection-change="handleSelectionChange"
              @sort-change="handleSortChange"
      >
        <el-table-column type="selection" width="55" align="center" />

        <el-table-column label="订单信息" align="center" width="300">
          <template slot-scope="scope">
            <div class="order-info">
              <div class="order-no">
                <span class="no-text">订单号：{{ scope.row.orderNo }}</span>
                <el-tag
                        v-if="scope.row.type === 1"
                        size="mini"
                        type="warning"
                        style="margin-left: 5px"
                >
                  开团
                </el-tag>
                <el-tag
                        v-else
                        size="mini"
                        type="success"
                        style="margin-left: 5px"
                >
                  参团
                </el-tag>
              </div>
              <div class="order-time">
                {{ parseTime(scope.row.createTime) }}
              </div>
              <div class="order-goods" v-if="scope.row.goodsInfo">
                <el-image
                        :src="scope.row.goodsInfo.image"
                        style="width: 40px; height: 40px; border-radius: 4px"
                        fit="cover"
                />
                <div class="goods-text">
                  <div class="goods-title">{{ scope.row.goodsInfo.title }}</div>
                  <div class="goods-spec" v-if="scope.row.specData">
                    <span v-for="(value, key) in scope.row.specData" :key="key">
                      {{ value }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="用户信息" align="center" width="180">
          <template slot-scope="scope">
            <div class="user-info">
              <div class="user-basic">
                <el-avatar
                        :src="scope.row.userAvatar"
                        :size="30"
                        style="margin-right: 10px"
                />
                <div>
                  <div class="user-nickname">{{ scope.row.userNickname }}</div>
                  <div class="user-phone">{{ scope.row.phone }}</div>
                </div>
              </div>
              <div class="user-address" v-if="scope.row.address">
                {{ scope.row.address }}
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="金额/数量" align="center" width="120">
          <template slot-scope="scope">
            <div class="amount-info">
              <div class="pay-amount">¥{{ scope.row.payAmount }}</div>
              <div class="quantity">x{{ scope.row.quantity }}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="支付信息" align="center" width="150">
          <template slot-scope="scope">
            <div class="pay-info">
              <div class="pay-type">
                <el-tag
                        size="mini"
                        :type="scope.row.payType === 1 ? 'success' : scope.row.payType === 2 ? 'warning' : 'info'"
                >
                  {{ getPayTypeText(scope.row.payType) }}
                </el-tag>
              </div>
              <div class="pay-time" v-if="scope.row.payTime">
                {{ parseTime(scope.row.payTime, '{y}-{m}-{d} {h}:{i}') }}
              </div>
              <div v-else class="not-pay">未支付</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="拼团信息" align="center" width="180">
          <template slot-scope="scope">
            <div v-if="scope.row.teamId" class="team-info">
              <div class="team-status">
                <el-tag
                        size="mini"
                        :type="getTeamStatusType(scope.row.teamStatus)"
                >
                  {{ getTeamStatusText(scope.row.teamStatus) }}
                </el-tag>
              </div>
              <div class="team-progress">
                {{ scope.row.teamCurrentSize }}/{{ scope.row.teamGroupSize }}人
              </div>
              <div class="team-expire" v-if="scope.row.teamStatus === 0">
                剩余{{ getTimeRemain(scope.row.teamExpireTime) }}
              </div>
            </div>
            <div v-else class="no-team">未加入团队</div>
          </template>
        </el-table-column>

        <el-table-column label="物流信息" align="center" width="180">
          <template slot-scope="scope">
            <div v-if="scope.row.expressCompany" class="express-info">
              <div class="express-company">
                {{ scope.row.expressCompany }}
              </div>
              <div class="express-no">
                {{ scope.row.expressNo }}
              </div>
              <div class="ship-time">
                {{ parseTime(scope.row.shipTime, '{y}-{m}-{d} {h}:{i}') }}
              </div>
            </div>
            <div v-else class="no-express">未发货</div>
          </template>
        </el-table-column>

        <el-table-column label="订单状态" align="center" width="100">
          <template slot-scope="scope">
            <el-tag
                    :type="getOrderStatusType(scope.row.status)"
                    effect="dark"
                    size="medium"
            >
              {{ getOrderStatusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="250" class-name="small-padding fixed-width">
          <template slot-scope="scope">
            <el-button
                    type="text"
                    icon="el-icon-view"
                    @click="handleView(scope.row)"
                    v-hasPermi="['order:query']"
            >
              详情
            </el-button>

            <!-- 状态相关操作 -->
            <el-dropdown @command="(command) => handleStatusCommand(command, scope.row)">
              <el-button type="text">
                状态操作<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                        v-if="scope.row.status === 0"
                        command="pay"
                        icon="el-icon-money"
                >
                  确认支付
                </el-dropdown-item>
                <el-dropdown-item
                        v-if="scope.row.status === 2"
                        command="ship"
                        icon="el-icon-truck"
                >
                  发货
                </el-dropdown-item>
                <el-dropdown-item
                        v-if="scope.row.status === 3"
                        command="receive"
                        icon="el-icon-circle-check"
                >
                  确认收货
                </el-dropdown-item>
                <el-dropdown-item
                        v-if="[0, 1, 2, 3].includes(scope.row.status)"
                        command="cancel"
                        icon="el-icon-circle-close"
                >
                  取消订单
                </el-dropdown-item>
                <el-dropdown-item
                        v-if="[0, 1, 2, 3, 4].includes(scope.row.status)"
                        command="refund"
                        icon="el-icon-refresh-left"
                >
                  退款
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <!-- 更多操作 -->
            <el-dropdown @command="(command) => handleMoreCommand(command, scope.row)">
              <el-button type="text">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="print" icon="el-icon-printer">
                  打印订单
                </el-dropdown-item>
                <el-dropdown-item command="remark" icon="el-icon-edit">
                  添加备注
                </el-dropdown-item>
                <el-dropdown-item command="team" icon="el-icon-user" v-if="scope.row.teamId">
                  团队详情
                </el-dropdown-item>
                <el-dropdown-item command="log" icon="el-icon-tickets">
                  操作日志
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination
              v-show="total > 0"
              :total="total"
              :page.sync="queryParams.pageNum"
              :limit.sync="queryParams.pageSize"
              @pagination="getList"
      />
    </el-card>

    <!-- 订单详情对话框 -->
    <el-dialog title="订单详情" :visible.sync="detailOpen" width="1100px" append-to-body>
      <div v-if="detailData" class="order-detail-dialog">
        <!-- 订单状态追踪 -->
        <div class="detail-section">
          <h3 class="section-title">订单状态追踪</h3>
          <el-steps :active="getStepActive(detailData.status)" align-center>
            <el-step title="已下单" :description="parseTime(detailData.createTime)" />
            <el-step
                    title="已支付"
                    :description="detailData.payTime ? parseTime(detailData.payTime) : '等待支付'"
                    icon="el-icon-money"
            />
            <el-step
                    title="拼团成功"
                    :description="detailData.teamStatus === 1 ? '拼团成功' : '等待成团'"
                    icon="el-icon-success"
            />
            <el-step
                    title="已发货"
                    :description="detailData.shipTime ? parseTime(detailData.shipTime) : '等待发货'"
                    icon="el-icon-truck"
            />
            <el-step
                    title="已完成"
                    :description="detailData.completeTime ? parseTime(detailData.completeTime) : '等待收货'"
                    icon="el-icon-circle-check"
            />
          </el-steps>
        </div>

        <el-row :gutter="20">
          <!-- 左侧信息 -->
          <el-col :span="14">
            <!-- 订单基本信息 -->
            <div class="detail-section">
              <h3 class="section-title">订单基本信息</h3>
              <el-descriptions :column="2" border>
                <el-descriptions-item label="订单编号">{{ detailData.orderNo }}</el-descriptions-item>
                <el-descriptions-item label="订单状态">
                  <el-tag :type="getOrderStatusType(detailData.status)" effect="dark">
                    {{ getOrderStatusText(detailData.status) }}
                  </el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="下单时间">{{ parseTime(detailData.createTime) }}</el-descriptions-item>
                <el-descriptions-item label="支付方式">{{ getPayTypeText(detailData.payType) }}</el-descriptions-item>
                <el-descriptions-item label="支付时间">{{ detailData.payTime ? parseTime(detailData.payTime) : '未支付' }}</el-descriptions-item>
                <el-descriptions-item label="支付流水号">{{ detailData.transactionId || '无' }}</el-descriptions-item>
              </el-descriptions>
            </div>

            <!-- 收货信息 -->
            <div class="detail-section">
              <h3 class="section-title">收货信息</h3>
              <el-descriptions :column="1" border>
                <el-descriptions-item label="收货人">{{ detailData.consignee }}</el-descriptions-item>
                <el-descriptions-item label="手机号码">{{ detailData.phone }}</el-descriptions-item>
                <el-descriptions-item label="收货地址">{{ detailData.address }}</el-descriptions-item>
              </el-descriptions>
            </div>

            <!-- 商品信息 -->
            <div class="detail-section">
              <h3 class="section-title">商品信息</h3>
              <div class="goods-info-card">
                <div class="goods-item">
                  <div class="goods-image">
                    <el-image
                            :src="detailData.goodsInfo.image"
                            fit="cover"
                            style="width: 80px; height: 80px"
                            :preview-src-list="detailData.goodsInfo.images"
                    />
                  </div>
                  <div class="goods-detail">
                    <div class="goods-title">{{ detailData.goodsInfo.title }}</div>
                    <div class="goods-spec" v-if="detailData.specData">
                      <span v-for="(value, key) in detailData.specData" :key="key">
                        {{ value }}
                      </span>
                    </div>
                    <div class="goods-price">¥{{ detailData.goodsAmount }}</div>
                  </div>
                  <div class="goods-quantity">
                    x{{ detailData.quantity }}
                  </div>
                </div>
              </div>
            </div>
          </el-col>

          <!-- 右侧信息 -->
          <el-col :span="10">
            <!-- 价格信息 -->
            <div class="detail-section">
              <h3 class="section-title">价格信息</h3>
              <div class="price-card">
                <div class="price-item">
                  <span class="price-label">商品总额：</span>
                  <span class="price-value">¥{{ detailData.goodsAmount }}</span>
                </div>
                <div class="price-item">
                  <span class="price-label">优惠金额：</span>
                  <span class="price-value">-¥{{ detailData.discountAmount }}</span>
                </div>
                <div class="price-item">
                  <span class="price-label">运费：</span>
                  <span class="price-value">+¥{{ detailData.shippingFee }}</span>
                </div>
                <div class="price-item total-price">
                  <span class="price-label">实付金额：</span>
                  <span class="price-value">¥{{ detailData.payAmount }}</span>
                </div>
              </div>
            </div>

            <!-- 拼团信息 -->
            <div class="detail-section" v-if="detailData.teamId">
              <h3 class="section-title">拼团信息</h3>
              <div class="team-card">
                <div class="team-header">
                  <div class="team-no">团队编号：{{ detailData.teamInfo.teamNo }}</div>
                  <div class="team-status">
                    <el-tag
                            :type="getTeamStatusType(detailData.teamInfo.status)"
                            size="small"
                    >
                      {{ getTeamStatusText(detailData.teamInfo.status) }}
                    </el-tag>
                  </div>
                </div>
                <div class="team-progress">
                  <el-progress
                          :percentage="Math.round((detailData.teamInfo.currentSize / detailData.teamInfo.groupSize) * 100)"
                          :color="detailData.teamInfo.status === 1 ? '#67c23a' : detailData.teamInfo.status === 2 ? '#f56c6c' : '#e6a23c'"
                  />
                  <div class="progress-text">
                    {{ detailData.teamInfo.currentSize }}/{{ detailData.teamInfo.groupSize }}人
                  </div>
                </div>
                <div class="team-members">
                  <div class="members-title">团队成员：</div>
                  <div class="members-list">
                    <div
                            v-for="member in detailData.teamInfo.members"
                            :key="member.id"
                            class="member-item"
                    >
                      <el-avatar
                              :src="member.avatar"
                              :size="30"
                              style="margin-right: 5px"
                      />
                      <div class="member-info">
                        <div class="member-name">{{ member.nickname }}</div>
                        <div class="member-time">{{ parseTime(member.joinTime, '{y}-{m}-{d} {h}:{i}') }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="team-expire" v-if="detailData.teamInfo.status === 0">
                  剩余时间：{{ getTimeRemain(detailData.teamInfo.expireTime) }}
                </div>
              </div>
            </div>

            <!-- 物流信息 -->
            <div class="detail-section" v-if="detailData.expressCompany">
              <h3 class="section-title">物流信息</h3>
              <div class="express-card">
                <div class="express-company">{{ detailData.expressCompany }}</div>
                <div class="express-no">运单号：{{ detailData.expressNo }}</div>
                <div class="ship-time">发货时间：{{ parseTime(detailData.shipTime) }}</div>

                <!-- 物流轨迹 -->
                <div class="express-trace" v-if="detailData.traceList && detailData.traceList.length > 0">
                  <div class="trace-title">物流轨迹：</div>
                  <div class="trace-list">
                    <div
                            v-for="(trace, index) in detailData.traceList"
                            :key="index"
                            class="trace-item"
                            :class="{ 'trace-active': index === 0 }"
                    >
                      <div class="trace-content">{{ trace.content }}</div>
                      <div class="trace-time">{{ trace.time }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 订单备注 -->
            <div class="detail-section">
              <h3 class="section-title">订单备注</h3>
              <div class="remark-card">
                <div class="remark-content" v-if="detailData.remark">
                  {{ detailData.remark }}
                </div>
                <div class="no-remark" v-else>
                  无备注信息
                </div>
                <el-button
                        type="text"
                        icon="el-icon-edit"
                        @click="editRemark(detailData)"
                >
                  添加备注
                </el-button>
              </div>
            </div>

            <!-- 操作记录 -->
            <div class="detail-section">
              <h3 class="section-title">操作记录</h3>
              <div class="operation-card">
                <div class="operation-list">
                  <div
                          v-for="(log, index) in detailData.operationLogs"
                          :key="index"
                          class="operation-item"
                  >
                    <div class="operation-content">{{ log.content }}</div>
                    <div class="operation-info">
                      <span class="operator">{{ log.operator }}</span>
                      <span class="operation-time">{{ parseTime(log.createTime, '{y}-{m}-{d} {h}:{i}') }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <!-- 发货对话框 -->
    <el-dialog title="订单发货" :visible.sync="shipOpen" width="500px" append-to-body>
      <el-form ref="shipForm" :model="shipForm" :rules="shipRules" label-width="100px">
        <el-form-item label="快递公司" prop="expressCompany">
          <el-select
                  v-model="shipForm.expressCompany"
                  placeholder="请选择快递公司"
                  style="width: 100%"
                  filterable
          >
            <el-option
                    v-for="company in expressCompanies"
                    :key="company.value"
                    :label="company.label"
                    :value="company.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="快递单号" prop="expressNo">
          <el-input
                  v-model="shipForm.expressNo"
                  placeholder="请输入快递单号"
          />
        </el-form-item>

        <el-form-item label="发货备注">
          <el-input
                  v-model="shipForm.remark"
                  type="textarea"
                  :rows="3"
                  placeholder="请输入发货备注（选填）"
          />
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitShip">确 定</el-button>
        <el-button @click="cancelShip">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 退款对话框 -->
    <el-dialog title="订单退款" :visible.sync="refundOpen" width="500px" append-to-body>
      <el-form ref="refundForm" :model="refundForm" :rules="refundRules" label-width="100px">
        <el-form-item label="订单金额">
          <div class="order-amount">¥{{ refundForm.payAmount }}</div>
        </el-form-item>

        <el-form-item label="退款金额" prop="refundAmount">
          <el-input-number
                  v-model="refundForm.refundAmount"
                  :min="0"
                  :max="refundForm.payAmount"
                  :precision="2"
                  :step="0.1"
                  controls-position="right"
                  style="width: 200px"
          />
        </el-form-item>

        <el-form-item label="退款方式" prop="refundType">
          <el-radio-group v-model="refundForm.refundType">
            <el-radio :label="1">原路退回</el-radio>
            <el-radio :label="2">退回余额</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="退款原因" prop="reason">
          <el-input
                  v-model="refundForm.reason"
                  type="textarea"
                  :rows="3"
                  placeholder="请输入退款原因"
          />
        </el-form-item>

        <el-form-item label="退款说明">
          <el-input
                  v-model="refundForm.remark"
                  type="textarea"
                  :rows="3"
                  placeholder="请输入退款说明（选填）"
          />
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitRefund">确 定</el-button>
        <el-button @click="cancelRefund">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 添加备注对话框 -->
    <el-dialog title="添加备注" :visible.sync="remarkOpen" width="500px" append-to-body>
      <el-form ref="remarkForm" :model="remarkForm" label-width="80px">
        <el-form-item label="订单编号">
          <div class="order-no-text">{{ remarkForm.orderNo }}</div>
        </el-form-item>

        <el-form-item label="备注内容" prop="remark">
          <el-input
                  v-model="remarkForm.remark"
                  type="textarea"
                  :rows="5"
                  placeholder="请输入备注内容"
                  maxlength="200"
                  show-word-limit
          />
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitRemark">确 定</el-button>
        <el-button @click="remarkOpen = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  // import { listOrder, getOrder, shipOrder, refundOrder, cancelOrder, completeOrder, updateOrderRemark, getOrderStats } from '@/api/order'
  // import { parseTime } from '@/utils'

  export default {
    name: 'groupOrderList',
    data() {
      return {
        // 遮罩层
        loading: true,
        // 选中数组
        ids: [],
        // 非多个禁用
        multiple: true,
        // 总条数
        total: 0,
        // 订单表格数据
        orderList: [],
        // 统计信息
        stats: {
          todayCount: 0,
          waitShip: 0,
          todayAmount: 0,
          successRate: 0
        },
        // 日期范围
        dateRange: [],
        // 查询参数
        queryParams: {
          pageNum: 1,
          pageSize: 10,
          orderNo: undefined,
          consignee: undefined,
          phone: undefined,
          status: undefined,
          payType: undefined,
          type: undefined
        },
        // 快递公司列表
        expressCompanies: [
          { value: 'SF', label: '顺丰速运' },
          { value: 'STO', label: '申通快递' },
          { value: 'YTO', label: '圆通速递' },
          { value: 'ZTO', label: '中通快递' },
          { value: 'YD', label: '韵达速递' },
          { value: 'EMS', label: 'EMS' },
          { value: 'JD', label: '京东物流' },
          { value: 'DBL', label: '德邦快递' }
        ],
        // 发货表单
        shipForm: {
          orderId: undefined,
          expressCompany: undefined,
          expressNo: undefined,
          remark: undefined
        },
        // 发货表单校验
        shipRules: {
          expressCompany: [
            { required: true, message: '请选择快递公司', trigger: 'blur' }
          ],
          expressNo: [
            { required: true, message: '请输入快递单号', trigger: 'blur' }
          ]
        },
        // 退款表单
        refundForm: {
          orderId: undefined,
          payAmount: 0,
          refundAmount: 0,
          refundType: 1,
          reason: undefined,
          remark: undefined
        },
        // 退款表单校验
        refundRules: {
          refundAmount: [
            { required: true, message: '请输入退款金额', trigger: 'blur' }
          ],
          reason: [
            { required: true, message: '请输入退款原因', trigger: 'blur' }
          ]
        },
        // 备注表单
        remarkForm: {
          orderId: undefined,
          orderNo: undefined,
          remark: undefined
        },
        // 是否显示发货弹出层
        shipOpen: false,
        // 是否显示退款弹出层
        refundOpen: false,
        // 是否显示备注弹出层
        remarkOpen: false,
        // 是否显示详情弹出层
        detailOpen: false,
        // 详情数据
        detailData: null,
        // 当前操作的行数据
        currentRow: null
      }
    },
    created() {
      this.getList()
      this.getStats()
    },
    methods: {
      // 获取订单列表
      getList() {
        this.loading = true
        this.$axios.listOrder(this.addDateRange(this.queryParams, this.dateRange)).then(response => {
          this.orderList = response.rows
          this.total = response.total
          this.loading = false
        })
      },

      // 获取统计信息
      getStats() {
        this.$axios.getOrderStats().then(response => {
          this.stats = response.data
        })
      },

      // 搜索
      handleQuery() {
        this.queryParams.pageNum = 1
        this.getList()
      },

      // 重置
      resetQuery() {
        this.dateRange = []
        this.resetForm('queryForm')
        this.handleQuery()
      },

      // 多选框选中数据
      handleSelectionChange(selection) {
        this.ids = selection.map(item => item.id)
        this.multiple = !selection.length
      },

      // 排序变化
      handleSortChange(column) {
        this.sortParams = {
          orderByColumn: column.prop,
          isAsc: column.order === 'ascending' ? 'asc' : 'desc'
        }
        this.getList()
      },

      // 查看详情
      handleView(row) {
        this.$axios.getOrder(row.id).then(response => {
          this.detailData = response.data
          this.detailOpen = true
        })
      },

      // 批量操作
      handleBatchCommand(command) {
        if (!this.ids.length) {
          this.$modal.msgWarning('请先选择订单')
          return
        }

        switch (command) {
          case 'batchShip':
            this.batchShip()
            break
          case 'batchComplete':
            this.batchComplete()
            break
          case 'batchCancel':
            this.batchCancel()
            break
        }
      },

      // 快捷筛选
      handleQuickFilter(command) {
        this.resetQuery()
        switch (command) {
          case 'waitPay':
            this.queryParams.status = 0
            break
          case 'waitShip':
            this.queryParams.status = 2
            break
          case 'waitReceive':
            this.queryParams.status = 3
            break
          case 'today':
            // const today = new Date()
            // today.setHours(0, 0, 0, 0)
            //       console.log(today)
            this.dateRange = [
             // parseTime(today.getTime(), '{y}-{m}-{d}'),
             // parseTime(today.getTime() + 86399000, '{y}-{m}-{d}')
            ]
            break
        }
        this.getList()
      },

      // 状态操作
      handleStatusCommand(command, row) {
        this.currentRow = row

        switch (command) {
          case 'pay':
            this.confirmPay(row)
            break
          case 'ship':
            this.handleShip(row)
            break
          case 'receive':
            this.confirmReceive(row)
            break
          case 'cancel':
            this.confirmCancel(row)
            break
          case 'refund':
            this.handleRefund(row)
            break
        }
      },

      // 更多操作
      handleMoreCommand(command, row) {
        switch (command) {
          case 'print':
            this.printOrder(row)
            break
          case 'remark':
            this.editRemark(row)
            break
          case 'team':
            this.$router.push({
              path: '/activity/team-detail',
              query: { id: row.teamId }
            })
            break
          case 'log':
            this.viewOperationLog(row)
            break
        }
      },

      // 确认支付
      confirmPay(row) {
        console.log(row)
        this.$confirm('确认该订单已支付吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 调用确认支付API
          // confirmPay(row.id).then(() => {
          //   this.getList()
          //   this.$modal.msgSuccess('确认支付成功')
          // })
        })
      },

      // 发货
      handleShip(row) {
        this.shipForm = {
          orderId: row.id,
          expressCompany: undefined,
          expressNo: undefined,
          remark: undefined
        }
        this.shipOpen = true
      },

      // 批量发货
      batchShip() {
        // 只能批量发货待发货的订单
        const shipOrders = this.orderList.filter(item =>
                this.ids.includes(item.id) && item.status === 2
        )

        if (shipOrders.length === 0) {
          this.$modal.msgWarning('选中的订单中没有待发货的订单')
          return
        }

        this.shipForm = {
          orderIds: this.ids,
          expressCompany: undefined,
          expressNo: undefined,
          remark: undefined
        }
        this.shipOpen = true
      },

      // 提交发货
      submitShip() {
        this.$refs['shipForm'].validate(valid => {
          if (valid) {
            this.$axios.shipOrder(this.shipForm).then(() => {
              this.$modal.msgSuccess('发货成功')
              this.shipOpen = false
              this.getList()
            })
          }
        })
      },

      // 取消发货
      cancelShip() {
        this.shipOpen = false
        this.resetForm('shipForm')
      },

      // 确认收货
      confirmReceive(row) {
        this.$confirm('确认该订单已收货吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.completeOrder(row.id).then(() => {
            this.getList()
            this.$modal.msgSuccess('确认收货成功')
          })
        })
      },

      // 批量完成
      batchComplete() {
        const completeOrders = this.orderList.filter(item =>
                this.ids.includes(item.id) && item.status === 3
        )

        if (completeOrders.length === 0) {
          this.$modal.msgWarning('选中的订单中没有待收货的订单')
          return
        }

        this.$confirm('确认批量完成选中的订单吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const requests = this.ids.map(id => this.$axios.completeOrder(id))
          Promise.all(requests).then(() => {
            this.getList()
            this.$modal.msgSuccess('批量完成成功')
          })
        })
      },

      // 确认取消
      confirmCancel(row) {
        this.$confirm('确认要取消该订单吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.cancelOrder(row.id).then(() => {
            this.getList()
            this.$modal.msgSuccess('取消成功')
          })
        })
      },

      // 批量取消
      batchCancel() {
        const cancelOrders = this.orderList.filter(item =>
                this.ids.includes(item.id) && [0, 1].includes(item.status)
        )

        if (cancelOrders.length === 0) {
          this.$modal.msgWarning('选中的订单中没有可取消的订单')
          return
        }

        this.$confirm('确认批量取消选中的订单吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const requests = this.ids.map(id => this.$axios.cancelOrder(id))
          Promise.all(requests).then(() => {
            this.getList()
            this.$modal.msgSuccess('批量取消成功')
          })
        })
      },

      // 退款
      handleRefund(row) {
        this.refundForm = {
          orderId: row.id,
          payAmount: row.payAmount,
          refundAmount: row.payAmount,
          refundType: 1,
          reason: undefined,
          remark: undefined
        }
        this.refundOpen = true
      },

      // 提交退款
      submitRefund() {
        this.$refs['refundForm'].validate(valid => {
          if (valid) {
            this.$axios.refundOrder(this.refundForm).then(() => {
              this.$modal.msgSuccess('退款成功')
              this.refundOpen = false
              this.getList()
            })
          }
        })
      },

      // 取消退款
      cancelRefund() {
        this.refundOpen = false
        this.resetForm('refundForm')
      },

      // 添加备注
      editRemark(row) {
        this.remarkForm = {
          orderId: row.id,
          orderNo: row.orderNo,
          remark: row.remark
        }
        this.remarkOpen = true
      },

      // 提交备注
      submitRemark() {
        if (!this.remarkForm.remark) {
          this.$modal.msgWarning('请输入备注内容')
          return
        }

        this.$axios.updateOrderRemark(this.remarkForm).then(() => {
          this.$modal.msgSuccess('添加备注成功')
          this.remarkOpen = false
          this.getList()
        })
      },

      // 打印订单
      printOrder(row) {
        // 实现打印功能
        const printContent = this.generatePrintContent(row)
        const printWindow = window.open('', '_blank')
        printWindow.document.write(printContent)
        printWindow.document.close()
        printWindow.print()
      },

      // 查看操作日志
      viewOperationLog(row) {
        this.$router.push({
          path: '/order/log',
          query: { orderId: row.id }
        })
      },

      // 获取剩余时间
      getTimeRemain(endTime) {
        if (!endTime) return ''

        const now = Date.now()
        const end = new Date(endTime).getTime()
        const diff = end - now

        if (diff <= 0) return '已结束'

        const hours = Math.floor(diff / (1000 * 60 * 60))
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))

        if (hours > 0) {
          return `${hours}小时${minutes}分`
        } else {
          return `${minutes}分钟`
        }
      },

      // 获取支付方式文本
      getPayTypeText(payType) {
        const typeMap = {
          1: '微信支付',
          2: '支付宝',
          3: '余额支付'
        }
        return typeMap[payType] || '未知'
      },

      // 获取团队状态文本
      getTeamStatusText(status) {
        const statusMap = {
          0: '拼团中',
          1: '拼团成功',
          2: '拼团失败',
          3: '已退款'
        }
        return statusMap[status] || '未知'
      },

      // 获取团队状态类型
      getTeamStatusType(status) {
        const typeMap = {
          0: 'warning',
          1: 'success',
          2: 'danger',
          3: 'info'
        }
        return typeMap[status] || 'info'
      },

      // 获取订单状态文本
      getOrderStatusText(status) {
        const statusMap = {
          0: '待支付',
          1: '拼团中',
          2: '待发货',
          3: '待收货',
          4: '已完成',
          5: '已取消',
          6: '已退款'
        }
        return statusMap[status] || '未知'
      },

      // 获取订单状态类型
      getOrderStatusType(status) {
        const typeMap = {
          0: 'warning',  // 待支付
          1: 'warning',  // 拼团中
          2: 'primary',  // 待发货
          3: 'info',     // 待收货
          4: 'success',  // 已完成
          5: 'danger',   // 已取消
          6: 'info'      // 已退款
        }
        return typeMap[status] || 'info'
      },

      // 获取步骤激活状态
      getStepActive(status) {
        const stepMap = {
          0: 1,  // 待支付
          1: 2,  // 拼团中
          2: 3,  // 待发货
          3: 4,  // 待收货
          4: 5,  // 已完成
          5: 1,  // 已取消
          6: 1   // 已退款
        }
        return stepMap[status] || 1
      },

      // 生成打印内容
      generatePrintContent(row) {
        return `
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="UTF-8">
          <title>订单打印</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 0; padding: 20px; }
            .print-header { text-align: center; margin-bottom: 20px; }
            .print-title { font-size: 24px; font-weight: bold; margin-bottom: 10px; }
            .order-info { margin-bottom: 20px; }
            .info-item { margin-bottom: 5px; }
            .info-label { font-weight: bold; }
            .goods-table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
            .goods-table th, .goods-table td { border: 1px solid #000; padding: 8px; text-align: center; }
            .summary { text-align: right; margin-top: 20px; }
          </style>
        </head>
        <body>
          <div class="print-header">
            <div class="print-title">拼团订单</div>
            <div>打印时间：${(Date.now())}</div>
          </div>

          <div class="order-info">
            <div class="info-item"><span class="info-label">订单编号：</span>${row.orderNo}</div>
            <div class="info-item"><span class="info-label">下单时间：</span>${(row.createTime)}</div>
            <div class="info-item"><span class="info-label">收货人：</span>${row.consignee}</div>
            <div class="info-item"><span class="info-label">联系电话：</span>${row.phone}</div>
            <div class="info-item"><span class="info-label">收货地址：</span>${row.address}</div>
          </div>

          <table class="goods-table">
            <thead>
              <tr>
                <th>商品名称</th>
                <th>规格</th>
                <th>单价</th>
                <th>数量</th>
                <th>小计</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>${row.goodsInfo.title}</td>
                <td>${row.specData ? Object.values(row.specData).join('/') : ''}</td>
                <td>¥${row.goodsAmount / row.quantity}</td>
                <td>${row.quantity}</td>
                <td>¥${row.goodsAmount}</td>
              </tr>
            </tbody>
          </table>

          <div class="summary">
            <div>商品总额：¥${row.goodsAmount}</div>
            <div>运费：¥${row.shippingFee}</div>
            <div>优惠金额：-¥${row.discountAmount}</div>
            <div style="font-size: 18px; font-weight: bold;">实付金额：¥${row.payAmount}</div>
          </div>
        </body>
        </html>
      `
      },

      // 导出
      handleExport() {
        this.download('/api/admin/order/export', {
          ...this.queryParams,
          ...this.dateRange
        }, `order_${new Date().getTime()}.xlsx`)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .app-container {
    padding: 20px;
  }

  .search-card {
    margin-bottom: 20px;
  }

  .stats-row {
    margin-bottom: 20px;

    .stats-card {
      height: 100px;

      .stats-content {
        display: flex;
        align-items: center;

        .stats-icon {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 20px;

          i {
            font-size: 30px;
            color: white;
          }
        }

        .stats-info {
          flex: 1;

          .stats-title {
            font-size: 14px;
            color: #999;
            margin-bottom: 5px;
          }

          .stats-value {
            font-size: 24px;
            font-weight: bold;
            color: #333;
          }
        }
      }
    }
  }

  .operate-card {
    margin-bottom: 20px;
  }

  .table-card {
    .order-info {
      .order-no {
        display: flex;
        align-items: center;
        margin-bottom: 5px;

        .no-text {
          font-weight: bold;
          color: #333;
        }
      }

      .order-time {
        font-size: 12px;
        color: #999;
        margin-bottom: 10px;
      }

      .order-goods {
        display: flex;
        align-items: center;

        .goods-text {
          margin-left: 10px;
          flex: 1;

          .goods-title {
            font-size: 14px;
            color: #333;
            margin-bottom: 3px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }

          .goods-spec {
            span {
              display: inline-block;
              padding: 2px 5px;
              background: #f5f7fa;
              border-radius: 3px;
              margin-right: 5px;
              font-size: 11px;
              color: #666;
            }
          }
        }
      }
    }

    .user-info {
      .user-basic {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        .user-nickname {
          font-size: 14px;
          color: #333;
          margin-bottom: 2px;
        }

        .user-phone {
          font-size: 12px;
          color: #666;
        }
      }

      .user-address {
        font-size: 12px;
        color: #999;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }

    .amount-info {
      .pay-amount {
        font-size: 18px;
        color: #f56c6c;
        font-weight: bold;
        margin-bottom: 5px;
      }

      .quantity {
        font-size: 14px;
        color: #666;
      }
    }

    .pay-info {
      .pay-time,
      .not-pay {
        font-size: 12px;
        color: #999;
        margin-top: 5px;
      }
    }

    .team-info {
      .team-status {
        margin-bottom: 5px;
      }

      .team-progress {
        font-size: 14px;
        color: #666;
        margin-bottom: 5px;
      }

      .team-expire {
        font-size: 12px;
        color: #f56c6c;
      }
    }

    .no-team,
    .no-express {
      font-size: 12px;
      color: #999;
    }

    .express-info {
      .express-company {
        font-size: 14px;
        color: #333;
        margin-bottom: 3px;
      }

      .express-no {
        font-size: 12px;
        color: #666;
        margin-bottom: 3px;
      }

      .ship-time {
        font-size: 12px;
        color: #999;
      }
    }
  }

  .order-detail-dialog {
    .detail-section {
      margin-bottom: 30px;

      .section-title {
        margin-bottom: 15px;
        padding-bottom: 10px;
        border-bottom: 1px solid #eee;
        font-size: 16px;
        color: #333;
      }
    }

    .goods-info-card {
      border: 1px solid #eee;
      border-radius: 4px;
      padding: 15px;

      .goods-item {
        display: flex;
        align-items: center;

        .goods-image {
          margin-right: 15px;
        }

        .goods-detail {
          flex: 1;

          .goods-title {
            font-size: 16px;
            color: #333;
            margin-bottom: 5px;
          }

          .goods-spec {
            margin-bottom: 5px;

            span {
              display: inline-block;
              padding: 2px 5px;
              background: #f5f7fa;
              border-radius: 3px;
              margin-right: 5px;
              font-size: 12px;
              color: #666;
            }
          }

          .goods-price {
            font-size: 18px;
            color: #f56c6c;
            font-weight: bold;
          }
        }

        .goods-quantity {
          font-size: 16px;
          color: #666;
        }
      }
    }

    .price-card {
      padding: 15px;
      background: #fafafa;
      border-radius: 4px;

      .price-item {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        font-size: 14px;
        color: #666;

        &.total-price {
          margin-top: 15px;
          padding-top: 15px;
          border-top: 1px solid #eee;
          font-size: 18px;
          color: #333;
          font-weight: bold;
        }
      }
    }

    .team-card {
      padding: 15px;
      background: #fafafa;
      border-radius: 4px;

      .team-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;

        .team-no {
          font-size: 14px;
          color: #333;
          font-weight: bold;
        }
      }

      .team-progress {
        margin-bottom: 15px;

        .progress-text {
          text-align: center;
          margin-top: 5px;
          font-size: 14px;
          color: #666;
        }
      }

      .team-members {
        .members-title {
          font-size: 14px;
          color: #333;
          margin-bottom: 10px;
        }

        .members-list {
          .member-item {
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            padding: 8px;
            background: white;
            border-radius: 4px;

            &:last-child {
              margin-bottom: 0;
            }

            .member-info {
              flex: 1;

              .member-name {
                font-size: 14px;
                color: #333;
                margin-bottom: 2px;
              }

              .member-time {
                font-size: 12px;
                color: #999;
              }
            }
          }
        }
      }

      .team-expire {
        margin-top: 15px;
        padding-top: 15px;
        border-top: 1px solid #eee;
        font-size: 14px;
        color: #f56c6c;
        text-align: center;
      }
    }

    .express-card {
      padding: 15px;
      background: #fafafa;
      border-radius: 4px;

      .express-company {
        font-size: 16px;
        color: #333;
        font-weight: bold;
        margin-bottom: 5px;
      }

      .express-no {
        font-size: 14px;
        color: #666;
        margin-bottom: 5px;
      }

      .ship-time {
        font-size: 14px;
        color: #666;
        margin-bottom: 15px;
      }

      .express-trace {
        .trace-title {
          font-size: 14px;
          color: #333;
          margin-bottom: 10px;
        }

        .trace-list {
          .trace-item {
            position: relative;
            padding-left: 20px;
            margin-bottom: 15px;

            &::before {
              content: '';
              position: absolute;
              left: 0;
              top: 5px;
              width: 8px;
              height: 8px;
              border-radius: 50%;
              background: #ddd;
            }

            &.trace-active::before {
              background: #409eff;
            }

            &::after {
              content: '';
              position: absolute;
              left: 3px;
              top: 15px;
              width: 2px;
              height: calc(100% + 5px);
              background: #ddd;
            }

            &:last-child::after {
              display: none;
            }

            .trace-content {
              font-size: 14px;
              color: #333;
              margin-bottom: 3px;
            }

            .trace-time {
              font-size: 12px;
              color: #999;
            }
          }
        }
      }
    }

    .remark-card {
      padding: 15px;
      background: #fafafa;
      border-radius: 4px;
      position: relative;

      .remark-content {
        font-size: 14px;
        color: #333;
        line-height: 1.5;
      }

      .no-remark {
        font-size: 14px;
        color: #999;
        text-align: center;
        padding: 20px 0;
      }

      .el-button {
        position: absolute;
        top: 15px;
        right: 15px;
      }
    }

    .operation-card {
      .operation-list {
        max-height: 200px;
        overflow-y: auto;

        .operation-item {
          padding: 10px;
          border-bottom: 1px solid #eee;

          &:last-child {
            border-bottom: none;
          }

          .operation-content {
            font-size: 14px;
            color: #333;
            margin-bottom: 5px;
          }

          .operation-info {
            display: flex;
            justify-content: space-between;
            font-size: 12px;
            color: #999;
          }
        }
      }
    }
  }

  .order-amount {
    font-size: 18px;
    color: #f56c6c;
    font-weight: bold;
  }

  .order-no-text {
    font-size: 16px;
    color: #333;
    font-weight: bold;
  }
</style>
